let config = null

export const setSiteConfig = data => {
  config = data
}

export const getSiteConfig = () => {
  if (!config) {
    throw new Error("No config")
  }
  return config
}
